import React from 'react';
import PropTypes from 'prop-types';
import css from './Overlay.css';

export default class Overlay extends React.Component {

  get overlayClass() {
    return this.props.visible ? `${css['sidebar-overlay']} ${css['expanded']}` : css['sidebar-overlay'];
  }

  render() {
    return <div className={this.overlayClass} onClick={this.props.onClick} />;
  }
}

Overlay.propTypes = {
  visible: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
